import { replaceRedactions } from "../helpers";

export default function initRedactions(id, small) {
  const elem = document.getElementById(id);
  elem.innerHTML = replaceRedactions(elem.innerHTML, small);
}
